import { Component, HostListener, OnInit } from "@angular/core";
import { environment } from "@environments/environment";
import { AuthenticationService, CommonService } from "@app/_services";
import { Router } from "@angular/router";
import { SmoothScrollService } from "@app/home/services/smooth-scroll.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.less"],
})
export class HeaderComponent implements OnInit {
  userName = "";
  menuList: any[];
  localLogin: string =
  environment.apiUrl + "authentication/localui/login?username=chinival";
  loginUrl: string;
  userData: any;
  authSubject: any;
  isAuthenticated: boolean = false;
  isScrolled = false;
  isMenuCollapsed = true;
  activeDropdown: string | null = null;

  constructor(
    public router: Router,
    private smoothScrollService: SmoothScrollService,
    private auth: AuthenticationService,
    private common: CommonService,
    private postLogin: AuthenticationService
  ) {}
  @HostListener("window:scroll", [])
  ngOnInit() {
    // this.userData = this.auth.currentUserValue;
    // if(this.userData !== null) {
    //   this.userName= this.userData.userMetadata.firstName;
    // }
    this.auth.isAuthSubject.subscribe((auth) => (this.isAuthenticated = auth));

    this.auth.currentUserSubject.subscribe((data: any) => {
      this.userData= data;
      if(this.userData !== null) {
        this.userName= this.userData.userMetadata.firstName;
      }
    });

    // this.loginUrl = environment.loginUrl;
  }

  login() {
    if (environment["environment"] === "local") {
      this.userData = this.auth.loginWithoutOkta().subscribe((res) => {
        this.userData = res.response;
        if (this.userData !== null) {
          this.userName = this.userData.userMetadata.firstName;
        }
        this.auth.postLogin(res.response, "http://localhost:4200/#relay/home");
      });
    } else {
      window.location.href = environment.loginUrl;
    }
  }

  isRouteActive(pathArray: any[]): boolean {
    let highlight: boolean = false;
    if (pathArray && pathArray.length != 0) {
      pathArray.forEach((path) => {
        if (this.router.isActive(path, false) == true) {
          highlight = true;
          return true;
        }
      });
    }
    return highlight;
  }

  logout() {
    this.auth.logout();
  }

  // Execution History dropdown options
  executionHistoryOptions = [
    {
      id: "recent",
      name: "Recent Executions",
      icon: "fa-circle",
      route: "/performance",
    },
    {
      id: "scheduled",
      name: "Scheduled Tests",
      icon: "fa-circle",
      route: "/performance",
    },
    {
      id: "reports",
      name: "Reports",
      icon: "fa-circle",
      route: "/performance",
    },
  ];

  // More dropdown options
  moreOptions = [
    { id: "users", name: "Users", icon: "fa-users", route: "/users" },
    { id: "documentation", name: "Documentation", icon: "fa-book" },
    { id: "settings", name: "Settings", icon: "fa-cog" },
    { id: "support", name: "Support", icon: "fa-question-circle" },
  ];

  onWindowScroll() {
    this.isScrolled = window.pageYOffset > 20;
  }

  toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
  }

  toggleDropdown(dropdown: string) {
    if (this.activeDropdown === dropdown) {
      this.activeDropdown = null;
    } else {
      this.activeDropdown = dropdown;
    }
  }

  isDropdownActive(dropdown: string): boolean {
    return this.activeDropdown === dropdown;
  }

  closeAllDropdowns(): void {
    this.activeDropdown = null;
  }

  scrollToSection(sectionId: string): void {
    this.smoothScrollService.scrollToElement(sectionId);
    this.closeAllDropdowns();
    this.isMenuCollapsed = true; // Close mobile menu after clicking
  }

  /**
   * Handle mouse enter event on dropdown menu items
   * @param dropdown The dropdown menu to show
   */
  onMouseEnter(dropdown: string): void {
    this.activeDropdown = dropdown;
  }

  /**
   * Handle mouse leave event on dropdown menu items
   * @param dropdown The dropdown menu to hide
   */
  onMouseLeave(dropdown: string): void {
    this.activeDropdown = null;
  }
}
